<template>
  <div class="relative flex">
    <slot />

    <span
      v-if="!hide"
      class="absolute grid place-content-center ring-2 ring-white h-(--height) w-(--width) rounded-full"
      :class="[
        $attrs.class,
        {
          '-bottom-(--offset) -right-(--offset)': placement === 'bottom',
          '-top-(--offset) -right-(--offset)': placement === 'top',
        },
      ]"
      :style="{
        '--width': `${size}px`,
        '--height': `${size}px`,
        '--offset': `${size / 10}px`,
      }"
    >
      <app-icon v-if="icon" :icon="icon" :size="size * 0.8" />
    </span>
  </div>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    size?: number;
    icon?: string;
    hide?: boolean;
    placement?: "bottom" | "top";
  }>(),
  {
    size: 12,
    icon: undefined,
    placement: "bottom",
  },
);
</script>
